import { Directive } from '@angular/core';
import { select } from '@ngxs/store';
import { LocalizationState } from '../state/localization.state';
import { BaseLocalizedFormatDirective } from './base-localized-format.directive';

/**
 * `wilsonUseLocalizedMonthYearFormat` directive
 *
 * Centralizes `nzFormat` for NG-ZORRO `nz-date-picker` / `nz-range-picker` in
 * **month** mode (`nzMode="month"`) using `LocalizationState.getLocalizedMonthYearFormat`.
 *
 * Usage:
 * ```html
 * <nz-date-picker nzMode="month" wilsonUseLocalizedMonthYearFormat></nz-date-picker>
 * <nz-range-picker nzMode="month" wilsonUseLocalizedMonthYearFormat></nz-range-picker>
 * ```
 *
 * Constraints:
 * - Only supports `nzMode="month"`.
 * - Do not set `nzFormat` manually when using this directive.
 *
 * Enforcement: custom ESLint rule `@wilson/require-wilson-nz-month-format` (warn by default).
 */
@Directive({
  selector:
    'nz-date-picker[wilsonUseLocalizedMonthYearFormat], nz-range-picker[wilsonUseLocalizedMonthYearFormat]',
  standalone: true,
})
export class UseLocalizedMonthYearFormatDirective extends BaseLocalizedFormatDirective {
  protected readonly directiveName = 'wilsonUseLocalizedMonthYearFormat';

  private readonly localizedMonthYearFormat = select(
    LocalizationState.getLocalizedMonthYearFormat,
  );

  protected override checkMode(mode?: string): void {
    if (mode !== 'month') {
      throw new Error(
        'wilsonUseLocalizedMonthYearFormat can only be used on nz-date-picker/nz-range-picker with nzMode="month"',
      );
    }
  }

  protected override applyCustomFormatEffects(): void {
    this.picker.nzFormat = this.localizedMonthYearFormat();
  }
}
